import type { FlagKind } from "../lib/types";
import { IconAlert, IconSpark } from "./icons";
import { Badge } from "./Badge";

/**
 * Drop / rise alert flag — a `Badge` in the reserved status tones. Colour ALWAYS
 * ships with an icon + text label (never colour alone). `reasons` are the tooltip.
 */
export function FlagBadge({
  flag,
  reasons = [],
  size = "sm",
}: {
  flag: FlagKind;
  reasons?: string[];
  size?: "sm" | "md";
}) {
  if (!flag) {
    return <span className="text-[10px] text-muted">Steady</span>;
  }
  const isDrop = flag === "drop";
  const Icon = isDrop ? IconAlert : IconSpark;
  const px = size === "sm" ? 11 : 13;
  return (
    <Badge
      tone={isDrop ? "critical" : "good"}
      size={size}
      title={reasons.join(" · ")}
      icon={<Icon width={px} height={px} />}
    >
      {isDrop ? "Drop" : "Rising"}
    </Badge>
  );
}
